export default {
  itemPaddingSmall: '0 4px',
  itemMarginSmall: '0 0 0 8px',
  itemMarginSmallRtl: '0 8px 0 0',
  itemPaddingMedium: '0 4px',
  itemMarginMedium: '0 0 0 8px',
  itemMarginMediumRtl: '0 8px 0 0',
  itemPaddingLarge: '0 4px',
  itemMarginLarge: '0 0 0 8px',
  itemMarginLargeRtl: '0 8px 0 0',
  buttonIconSizeSmall: '14px',
  buttonIconSizeMedium: '16px',
  buttonIconSizeLarge: '18px',
  inputWidthSmall: '60px',
  selectWidthSmall: 'unset',
  inputMarginSmall: '0 0 0 8px',
  inputMarginSmallRtl: '0 8px 0 0',
  selectMarginSmall: '0 0 0 8px',
  prefixMarginSmall: '0 8px 0 0',
  suffixMarginSmall: '0 0 0 8px',
  inputWidthMedium: '60px',
  selectWidthMedium: 'unset',
  inputMarginMedium: '0 0 0 8px',
  inputMarginMediumRtl: '0 8px 0 0',
  selectMarginMedium: '0 0 0 8px',
  prefixMarginMedium: '0 8px 0 0',
  suffixMarginMedium: '0 0 0 8px',
  inputWidthLarge: '60px',
  selectWidthLarge: 'unset',
  inputMarginLarge: '0 0 0 8px',
  inputMarginLargeRtl: '0 8px 0 0',
  selectMarginLarge: '0 0 0 8px',
  prefixMarginLarge: '0 8px 0 0',
  suffixMarginLarge: '0 0 0 8px'
};